import React from "react";
import { useSelector } from "react-redux"; // Import useSelector to get state from Redux
import { UserCreateMenu } from "../../../utils/constants";
import UserTabs from "../../common/UserTabs";
import NewDoctor from "../Partners/Doctor/NewDoctor";
import NewStore from "../Partners/Store/NewStore";

const CreatePartners = () => {
  const activeForm = useSelector((state) => state.formSwitcher.activeForm); // Get active form from Redux

  return (
    <>
      <main>
        {!activeForm ? (
          <div className="flex items-center mb-4">
            <UserTabs tabs={UserCreateMenu} showContent={true} />
          </div>
        ) : activeForm === "doctor" ? (
          <NewDoctor />
        ) : activeForm === "store" ? (
          <NewStore />
        ) : null}
      </main>
    </>
  );
};

export default CreatePartners;
